export default function AccessDenied() {
  return <h1>Access Denied</h1>
}
